let sliderThumbs, sliderImages;
let resizeTimeout; // 👈 for debouncing reset

function initSliders() {
  const isMobile = window.innerWidth <= 750;

  sliderThumbs = new Swiper(".slider-thumbs .swiper-container", {
    direction: isMobile ? "horizontal" : "vertical",
    slidesPerView: isMobile ? 4.3 : 6,
    spaceBetween: 7,
    freeMode: true
  });

  sliderImages = new Swiper(".slider-images .swiper-container", {
    direction: "horizontal",
    slidesPerView: 1,
    spaceBetween: 32,
    mousewheel: true,
    grabCursor: true,
    thumbs: {
      swiper: sliderThumbs
    }
  });

  console.log("✅ Sliders initialized");
}

function destroySliders() {
  console.log("🧹 Destroying sliders...");
  if (sliderThumbs && typeof sliderThumbs.destroy === "function") {
    sliderThumbs.destroy(true, true);
  }
  if (sliderImages && typeof sliderImages.destroy === "function") {
    sliderImages.destroy(true, true);
  }
  sliderThumbs = null;
  sliderImages = null;
}

// 👉 Function that really does the work of reset
function doHandleResizeOrRotate() {
  const currentWidth = window.innerWidth;
  const currentHeight = window.innerHeight;

  console.log(`🔁 Resize/orientation detected: ${currentWidth}x${currentHeight}`);

  const mobileZoomPort = document.querySelector('.mobile-zoom-port');
  const imageSliderPort = document.querySelector('.pdp-slider-main');

  // 0) Save the active slide index before destroying
  let lastActiveIndex = 0;
  if (sliderImages && typeof sliderImages.activeIndex === 'number') {
    lastActiveIndex = sliderImages.activeIndex;
  }
  console.log('[vertical-slider] lastActiveIndex before reset:', lastActiveIndex);

  // 1) Detect if the zoom was actually active (modal open + slider in zoom mode)
  const wasZoomOpen =
    !!mobileZoomPort &&
    mobileZoomPort.classList.contains('open') &&
    imageSliderPort &&
    imageSliderPort.classList.contains('mobile-zoom-slider');

  console.log('[vertical-slider] wasZoomOpen before resize:', wasZoomOpen);

  // 2) If it was open, only temporarily remove the "zoom" mode from the slider
  //    ⚠️ IMPORTANT: we no longer remove .open from the modal, so the frame doesn't "disappear"
  if (wasZoomOpen && imageSliderPort) {
    console.log('[vertical-slider] Temporarily disabling mobile-zoom-slider for reset');
    imageSliderPort.classList.remove('mobile-zoom-slider');
    imageSliderPort.style.position = '';
    imageSliderPort.style.zIndex = '';
    imageSliderPort.style.top = '';
    imageSliderPort.style.left = '';
    imageSliderPort.style.width = '';
    imageSliderPort.style.height = '';
  }

  // 3) Reset total of Swiper
  destroySliders();
  initSliders();

  // 3.1) Restore the active slide after reinitializing
  if (sliderImages && typeof sliderImages.slideTo === 'function') {
    console.log('[vertical-slider] Restoring active slide to index:', lastActiveIndex);
    sliderImages.slideTo(lastActiveIndex, 0, false);
  }

  // 4) If the zoom was active, reactivate only the "zoom" mode of the slider
  if (wasZoomOpen && imageSliderPort) {
    console.log('[vertical-slider] Re-enabling mobile-zoom-slider after reset');

    // Let the layout breathe for a tick
    setTimeout(() => {
      imageSliderPort.classList.add('mobile-zoom-slider');

      // ensure the fixed slider occupies the viewport
      imageSliderPort.style.position = 'fixed';
      imageSliderPort.style.zIndex = '400';
      imageSliderPort.style.width = '100%';
      imageSliderPort.style.height = '100%';

      // For safety, keep the active slide visible after reopening
      if (sliderImages && typeof sliderImages.update === 'function') {
        sliderImages.update();
      }
      if (sliderImages && typeof sliderImages.slideTo === 'function') {
        sliderImages.slideTo(lastActiveIndex, 0, false);
      }
      if (sliderThumbs && typeof sliderThumbs.update === 'function') {
        sliderThumbs.update();
      }

    }, 0);
  }
}

// 👉 Public handler for resize/orientation that only launches the reset once (debounce)
function handleResizeOrRotate() {
  if (resizeTimeout) {
    clearTimeout(resizeTimeout);
  }

  // Wait 120ms from the last event to execute the reset
  resizeTimeout = setTimeout(() => {
    doHandleResizeOrRotate();
  }, 120);
}

document.addEventListener("DOMContentLoaded", function () {
  setTimeout(() => {
    initSliders();

    window.addEventListener("resize", handleResizeOrRotate);
    window.addEventListener("orientationchange", handleResizeOrRotate);
  }, 300);
});